const developmentRestBaseUrl = "http://localhost:8080/WholsterRest";
const productionRestBaseUrl = "https://whaleshark.wholstersystems.com";

export const WHOLSTER_REST_BASE_URL =
  process.env.NODE_ENV === "production" ? productionRestBaseUrl : developmentRestBaseUrl;